import {LOAD_DIAS_FESTIVOS_SUCCESS} from "../types/diasFestivosActionTypes";
import useCommonApi from "../../api/useCommonApi";
import { IFechaFestiva } from "../../entities/catalogos/IFechaFestiva";

const apiSource = useCommonApi();

export function loadDiasFestivos() {
    return function (dispatch) {
        return apiSource.postAsync<IFechaFestiva[]>("solicitud-servicio/obtener-dias-festivos",{username: localStorage.getItem("usuario_nombre")})
            .then((diasFestivos: IFechaFestiva[]) => {
                dispatch({type: LOAD_DIAS_FESTIVOS_SUCCESS, diasFestivos})
            })
            .catch(error => {
                throw error;
            })
    }
}
